import React, { useEffect, createElement } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
const SignUp = () => {
  useEffect(() => {
    // Create and load the Typeform embed script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    // Cleanup function to remove the script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen flex flex-col bg-cream" data-id="element-653">
      {/* Header */}
      <header className="p-4 bg-white shadow-sm" data-id="element-654">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-655">
          <Link to="/" className="text-burgundy font-display text-2xl font-bold" data-id="element-656">
            Chef<span className="text-sage" data-id="element-657">Chat</span>
          </Link>
          <Link to="/" className="text-charcoal hover:text-burgundy flex items-center text-sm font-medium" data-id="element-658">
            <ArrowLeftIcon size={16} className="mr-1" data-id="element-659" />
            Back to home
          </Link>
        </div>
      </header>
      {/* Main content */}
      <main className="flex-grow flex flex-col items-center justify-center p-2" data-id="element-660">
        <div className="w-full max-w-6xl bg-white rounded-lg shadow-md p-3 md:p-4" data-id="element-661">
          <div className="text-center mb-4" data-id="element-662">
            <h1 className="text-2xl md:text-3xl font-bold text-charcoal font-display" data-id="element-663">
              Start Your Free Trial
            </h1>
            <p className="mt-2 text-sage" data-id="element-664">
              Complete the form below to begin your 14-day free trial. No credit
              card required.
            </p>
          </div>
          {/* Typeform embed container */}
          <div className="h-[600px] md:h-[700px] w-full" data-tf-live="01K6AZ46AX9D321QBT3RSRTT5P" data-id="element-665"></div>
        </div>
      </main>
      {/* Footer */}
      <footer className="p-4 bg-white border-t border-gray-200 mt-auto" data-id="element-666">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-sage" data-id="element-667">
          <p data-id="element-668">
            By signing up, you agree to our Terms of Service and Privacy Policy.
          </p>
        </div>
      </footer>
    </div>;
};
export default SignUp;